(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var honeypot = form.querySelector('.field--honeypot input');
    if (honeypot) {
      honeypot.setAttribute('aria-hidden', 'true');
      honeypot.parentElement.style.position = 'absolute';
      honeypot.parentElement.style.left = '-9999px';
    }
    form.addEventListener('submit', function(event) {
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        form.reset();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.scrollUpStartTop = 0;
      this.lastScrollDirection = null;
      this.pendingHeaderAction = null;
      this.headerActionFrame = null;
      this.isScrolling = null;
      this.headerResizeMediaQuery = null;

      this.onHeaderResize = this.onHeaderResize.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      this.headerResizeMediaQuery = window.matchMedia('(max-width: 990px)');
      this.addMediaQueryListener(this.headerResizeMediaQuery, this.onHeaderResize);
      window.addEventListener('resize', this.onHeaderResize);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = this.getScrollTop();
      this.scrollUpStartTop = this.currentScrollTop;
      this.scrollUpRevealDistance = this.getScrollUpRevealDistance();
      this.scrollTolerance = 4;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
        this.resetScrollUpTracking(this.getScrollTop());
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.hideHeaderOnScrollUp) {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      }

      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      window.removeEventListener('resize', this.onHeaderResize);
      this.removeMediaQueryListener(this.headerResizeMediaQuery, this.onHeaderResize);
      window.clearTimeout(this.isScrolling);

      if (this.headerActionFrame) {
        window.cancelAnimationFrame(this.headerActionFrame);
        this.headerActionFrame = null;
      }
    }

    addMediaQueryListener(mediaQuery, callback) {
      if (!mediaQuery) return;

      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', callback);
      } else if (mediaQuery.addListener) {
        mediaQuery.addListener(callback);
      }
    }

    removeMediaQueryListener(mediaQuery, callback) {
      if (!mediaQuery) return;

      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', callback);
      } else if (mediaQuery.removeListener) {
        mediaQuery.removeListener(callback);
      }
    }

    onHeaderResize() {
      this.setHeaderHeight();
      this.scrollUpRevealDistance = this.getScrollUpRevealDistance();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    getScrollTop() {
      return Math.max(window.pageYOffset || document.documentElement.scrollTop || 0, 0);
    }

    getHeaderScrollThreshold() {
      const observedBottom = Number(this.headerBounds?.bottom);

      if (Number.isFinite(observedBottom) && observedBottom > 0) {
        return observedBottom;
      }

      return this.header?.offsetHeight || 0;
    }

    getHeaderTopThreshold() {
      const observedTop = Number(this.headerBounds?.top);
      return Number.isFinite(observedTop) ? observedTop : 0;
    }

    getScrollUpRevealDistance() {
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      const configuredDistance = Number.parseInt(
        isMobile ? this.dataset.scrollUpRevealDistanceMobile : this.dataset.scrollUpRevealDistanceDesktop,
        10
      );

      if (Number.isFinite(configuredDistance) && configuredDistance >= 0) {
        return configuredDistance;
      }

      const headerHeight = this.header?.offsetHeight || 64;
      const minimumDistance = isMobile ? 32 : 48;
      const maximumDistance = isMobile ? 80 : 120;

      return Math.min(Math.max(Math.round(headerHeight * 0.75), minimumDistance), maximumDistance);
    }

    resetScrollUpTracking(scrollTop = this.getScrollTop()) {
      this.scrollUpStartTop = scrollTop;
      this.lastScrollDirection = null;
    }

    hasScrolledUpEnough(scrollTop) {
      return this.scrollUpStartTop - scrollTop >= this.scrollUpRevealDistance;
    }

    keepHeaderHiddenWhileRevealIsPrevented(scrollTop) {
      window.clearTimeout(this.isScrolling);

      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
        this.resetScrollUpTracking(this.getScrollTop());
      }, 66);

      this.scrollUpStartTop = scrollTop;
      this.requestHeaderAction('hide');
    }

    requestHeaderAction(action) {
      this.pendingHeaderAction = action;

      if (this.headerActionFrame) return;

      this.headerActionFrame = requestAnimationFrame(() => {
        const nextAction = this.pendingHeaderAction;

        this.headerActionFrame = null;
        this.pendingHeaderAction = null;

        if (typeof this[nextAction] === 'function') {
          this[nextAction]();
        }
      });
    }

    onScroll() {
      const scrollTop = this.getScrollTop();
      const scrollDifference = scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        this.resetScrollUpTracking(scrollTop);
        return;
      }

      if (this.header.classList.contains('menu-open')) {
        this.currentScrollTop = scrollTop;
        this.resetScrollUpTracking(scrollTop);
        return;
      }

      if (scrollTop <= this.getHeaderTopThreshold()) {
        this.header.classList.remove('scrolled-past-header');
        this.resetScrollUpTracking(scrollTop);
        this.requestHeaderAction('reset');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (Math.abs(scrollDifference) < this.scrollTolerance) return;

      const hasScrolledPastHeader = scrollTop > this.getHeaderScrollThreshold();

      if (hasScrolledPastHeader) {
        this.header.classList.add('scrolled-past-header');
      }

      if (scrollDifference > 0) {
        this.lastScrollDirection = 'down';
        this.scrollUpStartTop = scrollTop;

        if (hasScrolledPastHeader && !this.preventHide) {
          this.requestHeaderAction('hide');
        }
      } else {
        if (this.lastScrollDirection !== 'up') {
          this.scrollUpStartTop = this.currentScrollTop;
        }

        this.lastScrollDirection = 'up';

        if (this.preventReveal) {
          this.keepHeaderHiddenWhileRevealIsPrevented(scrollTop);
        } else if (this.hasScrolledUpEnough(scrollTop)) {
          this.requestHeaderAction('reveal');
        } else if (this.header.classList.contains('shopify-section-header-hidden')) {
          this.requestHeaderAction('hide');
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
